import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Experience } from './components/Experience';
import { Services } from './components/Services';
import { GiftCardsSection } from './components/GiftCardsSection';
import { Promise } from './components/Promise';
import { OneLiners } from './components/OneLiners';
import { FAQ } from './components/FAQ';
import { ContactCTA } from './components/ContactCTA';
import { GiftCards } from './pages/GiftCards';
import { RecentBookings } from './components/RecentBookings';
function MainSite() {
  return <div className="min-h-screen bg-rotterdam-black text-rotterdam-cream font-sans antialiased pt-16" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <Services data-id="element-3" />
      <GiftCardsSection data-id="element-4" />
      <Experience data-id="element-5" />
      <Promise data-id="element-6" />
      <OneLiners data-id="element-7" />
      <FAQ data-id="element-8" />
      <ContactCTA data-id="element-9" />
      <RecentBookings data-id="element-10" />
    </div>;
}
export function App() {
  return <Router data-id="element-11">
      <Routes data-id="element-12">
        <Route path="/" element={<MainSite data-id="element-14" />} data-id="element-13" />
        <Route path="/gift-cards" element={<GiftCards data-id="element-16" />} data-id="element-15" />
      </Routes>
    </Router>;
}